/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  position: relative;
  width: inherit;
  height: auto;
  path {
    fill: #f60;
  }
`

export default class MileageIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" css={Color}>
          <path
            id="icon_mileage"
            d="M-395-2101a39.568,39.568,0,0,1-15.333-2.847,39.571,39.571,0,0,1-12.933-8.808,39.285,39.285,0,0,1-8.867-12.847A38.843,38.843,0,0,1-435-2140.735a41.062,41.062,0,0,1,2.867-15.5,39.324,39.324,0,0,1,8.867-13.113,39.584,39.584,0,0,1,12.933-8.807A39.564,39.564,0,0,1-395-2181a39.569,39.569,0,0,1,15.334,2.848,39.578,39.578,0,0,1,12.934,8.807,39.326,39.326,0,0,1,8.866,13.113,41.067,41.067,0,0,1,2.867,15.5,38.314,38.314,0,0,1-11.732,28.079,39.563,39.563,0,0,1-12.934,8.808A39.573,39.573,0,0,1-395-2101Zm12.629-50.21h.228l-.1,1.039c-.39,3.875-.924,9.181-.924,12.846v17.659h7.716v-42.287h-9.372l-7.028,19.772c-.5,1.427-.953,2.937-1.393,4.4-.375,1.243-.76,2.52-1.178,3.774h-.286c-.266-.851-.53-1.718-.785-2.557-.568-1.867-1.155-3.8-1.786-5.614l-7.2-19.772h-9.372v42.287h7.6v-17.659c0-3.371-.488-8.085-.879-11.874-.073-.71-.143-1.383-.206-2.011h.228l3.372,9.942,6.572,17.771h4.856l6.514-17.771,3.428-9.941Z"
            transform="translate(435.001 2181.001)"
            fill="#f60"
          />
        </svg>
      </Fragment>
    )
  }
}
